import { getApiActionTypes } from '../../shared/store/storeHelpers';

export const fetchFilingStatesTypes = getApiActionTypes('FETCH_FILING_STATES');
